import { getModule } from 'vuex-module-decorators';

import auth_module, { initAuth } from './auth.module';
import jobs_module from './jobs.module';
import products_module from './products.module';
import services_module from './services.module';
import {
  JobAdditionalItems,
  moduleName as jobAddtionalItemsModuleName,
} from './job-additional-items';
import validation_module from './validation.module';
import invoices_module from './invoices.module';
import reports_module from './reports.module';

export const storeCommon = {
  modules: {
    auth: auth_module,
    jobs: jobs_module,
    products: products_module,
    services: services_module,
    validation: validation_module,
    invoices: invoices_module,
    reports: reports_module,
    [jobAddtionalItemsModuleName]: JobAdditionalItems,
  },
  plugins: [],
};

export function storeCommonInit(store: any) {
  initAuth(store);
}
